import { cloneDeep } from 'lodash';
import React, { useEffect, useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import { Loader } from 'react-feather';
import { toast } from 'react-toastify';
import img_bg_upload from '../assets/images/file-drop-upload.png';
import icon_img_delete from '../assets/images/icon_img_delete.png';
import document_img from '../assets/images/document_image.png'
import APIClient from '../helpers/APIClient';
import { getBase64All } from '../helpers/UploadUtils';

/**
 * Renders the PageTitle
 */
interface rootProps{
    handleChangeFile?:any,
    fileTypes?:any,
    imgs?:any,
    disabled?:boolean,
}

export const handleUpload = async (file:any) => {
    if(!file) return false
    console.log("11",file);
    if(file?.size > (5 * 1024 * 1024)) {
        toast.warning("kích thước hình ảnh không được vượt quá 2MB")
        return false
    }
    let dtaForm = new FormData();
    let url = ''
    dtaForm.append("file", file);
    const responeImage:any =  await APIClient.POST('/images/nutri-products',dtaForm)
    if(responeImage && responeImage.response){
        url =responeImage.response
    }
    return url
}

const ProductFileUpload = (props:rootProps) => {
    const [loading, setLoading] = useState(false);
    const { fileTypes, imgs, disabled} = props
    const [filesBase64, setFilesBase64] = useState<any>(imgs);

    useEffect(() => {
        let timerSetData = setTimeout(
            ()=> {
                setFilesBase64(imgs)
            },
            300
        );
        return () => {
            clearTimeout(timerSetData);
          };
    }, [imgs]);

    
    const handleUploadImage = async (imgs:any) => {
        if(imgs?.length === 0) return []
        return new Promise(resolve => {
            let image_ids:any = [];
            Array.from(imgs)?.map(async(file:any, index:number)=>{
                const url = await handleUpload(file);
                if(url) image_ids.push({
                    ...file,
                    url: url
                });
                if(imgs?.length === image_ids?.length){
                    resolve(image_ids);
                }
            })
            return image_ids
        });
    }

    const handleChangeFile = async (files:any) => {
        console.log("22");
        setLoading(true)
        const image_ids:any = await handleUploadImage(files);
        const imgs = [...filesBase64, ...image_ids]
        props?.handleChangeFile(imgs);
        setLoading(false)
    };

    const handleRemove = async (index:number) => {
        const newData = cloneDeep(filesBase64)
        newData.splice(index, 1);
        props?.handleChangeFile(newData);
    };
    const handleDownload = (item:any) => {
        console.log('handleDownload',item)
        APIClient.DOWNLOAD(item?.image_url);
    };
    
    return (
            <div className="file-drop-img-list">
                <div className="tee-multiple-file-preview">
                    {filesBase64?.map((item:any, index:number)=>{
                        console.log("itemsiuuu", item);
                        const imgDoc = () => {
                            if(item?.url?.endsWith(".PDF") || item?.url?.endsWith(".docx") || item?.url?.endsWith(".xlsx") || item?.url?.endsWith(".pdf")) {
                              return document_img
                            }else {
                              return item?.url
                            }
                          }
                        return(
                            <div key={`img-${index}`} className="tee-multiple-file-preview-item" style={{width:'auto'}} onClick={()=>disabled && handleDownload(item)}>
                                <div className="img-item">
                                    {!disabled &&
                                    <span className='icon-delete'>
                                        <img src={icon_img_delete} onClick={()=>handleRemove(index)} />
                                        {/* <i className="uil uil-trash-alt" onClick={()=>handleRemove(index)} /> */}
                                    </span>
                                    }
                                    <img src={imgDoc()} />
                                    {/* <i className="uil uil-file-upload file-upload-icon"></i> */}
                                    <span className="file-info">{item?.name}</span>
                                </div>
                            </div>
                        )
                    })}
                    {disabled ? null :
                    <div className="tee-multiple-file-preview-item" style={{width:'auto'}}>
                        <FileUploader
                            multiple={true}
                            handleChange={handleChangeFile}
                            name="file"
                            types={fileTypes}
                            classes="file-drop-img"
                            disabled={disabled}
                        >
                            <div className="img-item" style={{border:'none', cursor:'pointer'}}>
                                <img src={img_bg_upload}/>
                            </div>
                        </FileUploader>
                    </div>}
                </div>
                {loading && <Loader />}
            </div>
    )
}

export default ProductFileUpload;